import React from "react";
import { MyUI } from "apps/Components";

class SC_GridView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      style: {
        gap: 10,
        display: "grid",
      },
      settings: [
        { width: 1100, column: 3 },
        { width: 600, column: 2 },
        { width: 0, column: 1 },
      ],
      id: null,
    };
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.getStyle);
  }
  componentDidMount() {
    const { settings, layoutStyle } = this.props;
    if (settings) {
      const { style } = this.state;
      this.setState(
        {
          settings: settings,
          style: {
            ...style,
            ...layoutStyle,
          },
        },
        () => this.getStyle({ forceStyle: layoutStyle })
      );
    }
    this.getStyle();
    window.addEventListener("resize", this.getStyle);
  }
  shouldComponentUpdate(nextProps) {
    const nextSettings = nextProps.settings;
    const currentSettings = this.props.settings;
    if (currentSettings !== nextSettings) {
      this.setState(
        {
          settings: nextSettings,
        },
        () => this.getStyle()
      );
    }
    return true;
  }
  getStyle = ({ otherSettings, forceStyle } = {}) => {
    const { fnList } = this.props;
    let { style, settings } = this.state;
    const _settings = otherSettings || settings;
    const _screenWidth = window.innerWidth;
    let _gridTemplateColumns = "";
    let myStyle = {
      ...style,
      ...forceStyle,
    };
    _settings.every((v) => {
      if (_screenWidth >= v.width) {
        for (let i = 0; i < v.column; i++) {
          _gridTemplateColumns += ` calc(${100 / v.column}% - ${
            (myStyle.gap * (v.column - 1)) / v.column
          }px)`;
        }
        return false;
      }
      return true;
    });
    this.setState(
      {
        style: {
          ...myStyle,
          gridTemplateColumns: _gridTemplateColumns,
        },
        ...(otherSettings && { settings: otherSettings }),
      },
      () => {
        this.forceUpdate();
        if (fnList?.updateStyle) {
          fnList.updateStyle();
        }
      }
    );
  };
  render() {
    const { id, data, cardType, config, renderComponent, fnList } = this.props;
    const { style } = this.state;
    return (
      <div id={id} style={style}>
        {renderComponent && renderComponent()}
        {!renderComponent &&
          data?.length > 0 &&
          data.map((v, i) => {
            return (
              <MyUI
                key={i}
                type={cardType}
                data={v}
                config={config}
                fnList={fnList}
              />
            );
          })}
      </div>
    );
  }
}
export default SC_GridView;
